export default __webpack_public_path__ + "static/media/Logo.9793fe87.svg";